import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { Button } from "../../button/src";
import { CATEGORIES, FontAwesomeIcon } from "../../font-awesome-icon/src";
import { useTheme } from "../../theme/src";
const Label = ({ children, theme }) => children ? (_jsx(Box, { color: theme.input.color, font: "metadata-regular-asphalt", px: 2, textAlign: "center", children: children })) : null;
const UploadButton = ({ label, onClick, }) => (_jsx(Button, { mt: 3, onClick: onClick, variant: "primary", children: label }));
export const Description = ({ description, hasChildren, isHover, isMobileAndNotEmpty, onUpload, title, }) => {
    var _a, _b, _c, _d;
    const theme = useTheme();
    const displayTitle = typeof title === 'undefined'
        ? ((_a = window === null || window === void 0 ? void 0 : window.__) === null || _a === void 0 ? void 0 : _a.call(window, 'Drag and drop your files')) || 'Drag and drop your files'
        : title;
    if (hasChildren) {
        return (_jsxs(ContentWrapper, { "$isMobileAndNotEmpty": isMobileAndNotEmpty, children: [description && _jsx(Label, { theme: theme, children: description }), _jsx(UploadButton, { label: ((_b = window === null || window === void 0 ? void 0 : window.__) === null || _b === void 0 ? void 0 : _b.call(window, 'Upload files')) || 'Upload files', onClick: onUpload })] }));
    }
    if (isHover) {
        return (_jsxs(ContentWrapper, { children: [_jsx(FontAwesomeIcon, { color: theme.colors.white, height: "64px", iconName: "file", iconType: CATEGORIES.DUOTONE }), _jsx(Box, { color: "white", font: "h3-semibold", mb: 3, mt: 6, px: 2, children: ((_c = window === null || window === void 0 ? void 0 : window.__) === null || _c === void 0 ? void 0 : _c.call(window, 'Drop your files here!')) || 'Drop your files here!' })] }));
    }
    return (_jsxs(ContentWrapper, { children: [displayTitle && (_jsx(Box, { color: theme.input.color, font: "h3-semibold", mb: 2, textAlign: "center", children: displayTitle })), description && _jsx(Label, { theme: theme, children: description }), _jsx(UploadButton, { label: ((_d = window === null || window === void 0 ? void 0 : window.__) === null || _d === void 0 ? void 0 : _d.call(window, 'Upload files')) || 'Upload files', onClick: onUpload })] }));
};
const ContentWrapper = styled(Box).attrs(({ $isMobileAndNotEmpty, theme }) => ({
    alignItems: 'center',
    bg: $isMobileAndNotEmpty && theme.input.bg,
    borderRadius: $isMobileAndNotEmpty && theme.input.borderRadius,
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    justifyContent: 'center',
    mt: $isMobileAndNotEmpty && 4,
    pb: 8,
    pt: 6,
    px: 10,
    width: '100%',
})) `
  border-radius: ${({ theme }) => theme.input.borderRadius}px;
`;
//# sourceMappingURL=Description.js.map